import React, { useState } from "react";
import { Box } from "@mui/system";
import { SetupsOverview, DataSetupForm, DataSetupDetails } from "./components";
import { VIEWS } from "./consts";

export const EmissionsAllocationTab = () => {
    const [view, setView] = useState(VIEWS.OVERVIEW);
    const [selectedAllocationId, setSelectedAllocationId] = useState<number | null>(null);

    const changeView = (newView: string) => setView(newView);

    const onOpenSetupDetailsHandler = (allocationId: number) => {
        setSelectedAllocationId(allocationId)
        changeView(VIEWS.DETAILS);
    }

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column' }}>
            {view === VIEWS.OVERVIEW && (
                <SetupsOverview
                    onAddNewAllocationSetup={() => changeView(VIEWS.FORM)}
                    onViewDetails={onOpenSetupDetailsHandler}
                />
            )}
            {view === VIEWS.FORM && (
                <DataSetupForm
                    onBackToOverview={() => changeView(VIEWS.OVERVIEW)}
                    onFormSubmition={onOpenSetupDetailsHandler}
                />
            )}
            {view === VIEWS.DETAILS && selectedAllocationId && (
                <DataSetupDetails allocationId={selectedAllocationId} onBackToOverview={() => changeView(VIEWS.OVERVIEW)}
                />
            )}
        </Box>
    );
};